module.exports = __webpack_public_path__ + "static/about-38b40e104c21810bb27b25393403724e.jpg";